import { messages } from 'AuthPart/authpart.messages';

export const DefaultError = messages['error.default'];

export const loginErrors = new Map([[
    messages['server.username.error'],
    messages['server.email.cantFind.error']
]]);
